/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CommissionId} from "./commissionId.zod";
import {ContactId} from "./contactId.zod";

export const RepresentativeSelection = zod.object({
  representativeId: zod.uuid(),
  contactId: ContactId,
  commissionId: zod.union([CommissionId, zod.null()]).optional(),
});

export type RepresentativeSelection = zod.input<typeof RepresentativeSelection>;
export type RepresentativeSelectionOutput = zod.output<typeof RepresentativeSelection>;
